import { render, staticRenderFns } from "./TerminateUserModal.vue?vue&type=template&id=47567721"
import script from "./TerminateUserModal.vue?vue&type=script&lang=js"
export * from "./TerminateUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports